import { appStrings } from '@backrs_ui/grow-ui/src/assets/appStrings';
import {
  USER_COLLEGE_STATUSES,
  UserCollege,
  UserCollegeStatus,
} from '@backrs_ui/grow-ui/src/redux/userColleges/userColleges.types';

import { CHIP_TONES, ChipOption, ChipTone, OptionChip } from './OptionChip';

const STRINGS = appStrings.modules.myColleges;

export const STATUS_TONES: Record<UserCollegeStatus, ChipTone> = {
  interested: CHIP_TONES.neutral,
  applying: CHIP_TONES.brand,
  applied: CHIP_TONES.brand,
  accepted: CHIP_TONES.success,
  enrolled: CHIP_TONES.success,
  waitlisted: CHIP_TONES.warning,
  denied: CHIP_TONES.error,
};

const STATUS_OPTIONS: readonly ChipOption<UserCollegeStatus>[] = USER_COLLEGE_STATUSES.map(
  (status) => ({ value: status, label: STRINGS.statusLabels[status], tone: STATUS_TONES[status] }),
);

type StatusChipProps = Readonly<{
  id: string;
  college: UserCollege;
  onChange: (status: UserCollegeStatus) => void;
}>;

export const StatusChip = ({ id, college, onChange }: StatusChipProps) => (
  <OptionChip id={id} value={college.status} options={STATUS_OPTIONS} onChange={onChange} />
);
